<div hive-root>
    <!-- The rail and platform-page-layout. OnPush: it is checked only when one of these bindings changes. -->
    <app-rail
        [tabs]="tabsToRender"
        [activeItemId]="activeTabId"
        (activeItemIdChange)="activeTabId = $event"
        [activeNavigation]="activeNavigation"
        [showRecommendations]="hasProRecFeature && proRecOpaCheck"
        [recommendationCount]="recommendationCount"
        [notificationCount]="notificationCount$ | async"
        [showOrgSwitcher]="showOrgSwitcher$ | async"
        [isOrgSwitcherReadonly]="isOrgSwitcherReadonly"
        [isVmAssessmentsBetaEnabled]="(isVmAssessmentsBetaEnabled$ | async) === true"
        [isEOSCEnabled]="isEOSCEnabled"
        [showEolApplianceBadge]="showEolApplianceBadge"
        [eolApplianceCount]="eolApplianceCount"
        [showEolOrEoscApplianceBadge]="showEolOrEoscApplianceBadge"
        [eolOrEoscApplianceCount]="eolOrEoscApplianceCount"
        [eolOrEoscApplianceTooltip]="eolOrEoscApplianceTooltip"
        [expiredSupportContractCount]="expiredSupportContractCount"
        [showArrayCountBadge]="showArrayCountBadge"
        [arrayCounts]="arrayCounts"
        [openAlertsCount]="openAlertsCount"
        [alertsEmphasisBadge]="alertsEmphasisBadge"
        [openCasesCount]="supportCaseOrchestrator.numOfOpenCases"
        [pageHelpUrl]="pageHelpUrl"
        [canReadSupportKnowledge]="canReadSupportKnowledge()"
        [canReadSupportCommunity]="canReadSupportCommunity()"
        [communityUrl]="getCommunityUrl()"
        (collapseToggle)="onCollapseToggle($event)"
        (recommendationsClick)="handleClickProRecIcon()"
        (backClick)="backToPure1()"
        (orgSwitchError)="onOrgSwitchError($event)"
        (helpItemClick)="handleHelpItemClick($event)"
        (appSwitcherVisibilityChange)="onAppSwitcherVisibilityChange($event)"
        (appSwitcherAppClick)="onAppSwitcherAppClick($event)"
    >
        <!-- Main page content -->
        <div id="tab-content" class="hive-page" [class.hive-page--full-bleed]="fullBleed">
            @if (pageTitle?.length > 0) {
                <div class="page-title">
                    <span class="page-title-text">{{ pageTitle }}</span>
                    @if (pageTitle === 'Overview' && isEOSCEnabled && eoscApplianceCount > 0) {
                        <svg
                            class="info-circle"
                            [height]="13"
                            hiveTooltip
                            hiveTooltipDescription="Certain aggregated fleet metrics for Volumes, File Systems, and Pods may include values from Out of Support Arrays."
                            hive-svg="info-circle.svg"
                        ></svg>
                    }
                    @if (copilotPromptLinks.length > 0) {
                        <span class="page-title-copilot-links">
                            @for (link of copilotPromptLinks; track link.prompt) {
                                <copilot-prompt-link [label]="link.label" [prompt]="link.prompt" />
                            }
                        </span>
                    }
                </div>
            }

            <router-outlet></router-outlet>
        </div>

        <export-overlay (overlayVisibleChange)="onActiveExportsChanged($event)"></export-overlay>

        <!-- Feedback Button -->
        <!-- NOTE: The `pageTitle !== undefined` is for copilot -->
        @if (showFeedbackButton || (pageTitle !== 'Planning' && pageTitle !== 'Users' && pageTitle !== undefined)) {
            <feedback-button
                [ngClass]="pageTitle !== 'Map View' ? 'feedback-btn-general' : 'feedback-btn-mapview'"
            ></feedback-button>
        }

        <!-- NPS feedback form -->
        <feedback-form></feedback-form>
    </app-rail>

    <!--
        Toast notifications.
        Kept OUTSIDE platform-page-layout on purpose: that layout establishes a stacking context, and
        being trapped in it broke the toast's own positioning and layering against page content.
        Note this is NOT what keeps the toast above Hive dialogs -- no z-index can do that, because
        Angular CDK renders its overlays in the browser top layer. pure-toast joins that top layer
        itself; see PureToastComponent.syncTopLayer(). (CLOUD-234425)
    -->
    <pure-toast />

    <!-- At top-level since it is triggered by the app navigation -->
    <copilot-onboarding-modal-internal></copilot-onboarding-modal-internal>

    <!-- Copilot side panel: hidden when the feature flag is off or when on the full-page Copilot route -->
    @if ((copilotSidePanelEnabled$ | async) && !(isCopilotRoute$ | async)) {
        <copilot-side-panel
            [isOpen]="(copilotSidePanelService.isOpen$ | async) ?? false"
            [conversation]="copilotChatController.conversation"
            [allConversations]="copilotChatController.allConversations"
            [waitingForInputResponse]="copilotChatController.waitingForInputResponse"
            [conversationLoading]="copilotChatController.conversationLoading"
            [feedbackStates]="copilotChatController.feedbackStates"
            [triageActive]="!!copilotChatController.pendingInterrupt"
            (submitMessage)="copilotChatController.submitMessage($event)"
            (stopMessage)="copilotChatController.stopMessage()"
            (regenerateResponse)="copilotChatController.regenerateResponse()"
            (setVariation)="copilotChatController.setVariation($event)"
            (selectConversation)="copilotChatController.selectConversation($event)"
            (deleteConversation)="copilotChatController.deleteConversation($event)"
            (submitFeedback)="copilotChatController.submitInitialFeedback($event)"
            (submitAdditionalFeedback)="copilotChatController.submitAdditionalFeedback($event)"
            (closeAdditionalFeedback)="copilotChatController.closeAdditionalFeedback($event)"
            (newChat)="copilotChatController.startNewChat()"
            (expand)="onSidePanelExpand()"
            (closePanel)="copilotSidePanelService.close()"
            (exitTriage)="copilotChatController.exitTriage()"
        >
            <copilot-page-suggestions
                copilotPreInputContent
                [hidden]="!copilotSidePanelQuestionsEnabled"
            ></copilot-page-suggestions>
            <copilot-page-summary copilotEmptyState [enabled]="copilotSidePanelSummarizeEnabled"></copilot-page-summary>
        </copilot-side-panel>
    }
</div>

<!-- All of css stuff, need to find it a better home -->
<!-- Used by cssUrlStyleManager -->

<!-- SVG filter definitions. Used by cssUrlStyleManager. -->
<svg style="position: absolute; left: 0; top: 0; width: 0; height: 0; z-index: -100; pointer-events: none">
    <defs>
        <!--
            General
        -->
        <!-- Drop-shadow for svgs. Intended to roughly match (or look good with) text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5) -->
        <filter id="svg-hover-dropshadow" x="-40%" y="-40%" width="200%" height="200%">
            <!-- Offset the image 2px -->
            <feOffset in="SourceAlpha" result="saOffset" dx="2" dy="2"></feOffset>
            <!-- Blur it -->
            <feGaussianBlur in="saOffset" result="saOffsetBlur" stdDeviation="2"></feGaussianBlur>
            <!-- Adjust color channels, leaving only a black w/ alpha -->
            <feColorMatrix
                in="saOffsetBlur"
                result="saOffsetBlurColor"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
            ></feColorMatrix>
            <feMerge>
                <feMergeNode in="saOffsetBlurColor"></feMergeNode>
                <feMergeNode in="SourceGraphic"></feMergeNode>
            </feMerge>
        </filter>

        <!--
            FA Health - Zepto
        -->
        <pattern id="pattern-stripe" width="8" height="8" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
            <rect width="4" height="8" fill="#828282"></rect>
        </pattern>

        <!--
            FB Health
        -->
        <linearGradient id="fb-health-healthy" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stop-color="#8dc63f"></stop>
            <stop offset="50%" stop-color="#8dc63f"></stop>
            <stop offset="50%" stop-color="#81b53a"></stop>
            <stop offset="100%" stop-color="#8dc63f"></stop>
        </linearGradient>
        <linearGradient id="fb-health-failed" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stop-color="#d84c41"></stop>
            <stop offset="50%" stop-color="#d84c41"></stop>
            <stop offset="50%" stop-color="#c14c3b"></stop>
            <stop offset="100%" stop-color="#d84c41"></stop>
        </linearGradient>
        <linearGradient id="fb-health-unhealthy" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stop-color="#e8c721"></stop>
            <stop offset="50%" stop-color="#e8c721"></stop>
            <stop offset="50%" stop-color="#dcbd00"></stop>
            <stop offset="100%" stop-color="#e8c721"></stop>
        </linearGradient>
        <linearGradient id="fb-health-unused" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stop-color="#8f8f8f"></stop>
            <stop offset="50%" stop-color="#8f8f8f"></stop>
            <stop offset="50%" stop-color="#848484"></stop>
            <stop offset="100%" stop-color="#8f8f8f"></stop>
        </linearGradient>
        <linearGradient id="fb-health-default" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stop-color="#d9d9d9"></stop>
            <stop offset="50%" stop-color="#d9d9d9"></stop>
            <stop offset="50%" stop-color="#cacaca"></stop>
            <stop offset="100%" stop-color="#d9d9d9"></stop>
        </linearGradient>

        <!--
            VMware Metrics Topology
        -->
        <filter id="vm-topology-dropshadow" x="-20%" y="-20%" width="140%" height="140%">
            <!-- Offset the image 2px -->
            <feOffset in="SourceAlpha" result="saOffset" dx="2" dy="2"></feOffset>
            <!-- Blur it -->
            <feGaussianBlur in="saOffset" result="saOffsetBlur" stdDeviation="2"></feGaussianBlur>
            <!-- Adjust color channels, leaving only a black w/ alpha -->
            <feColorMatrix
                in="saOffsetBlur"
                result="saOffsetBlurColor"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            ></feColorMatrix>
            <feMerge>
                <feMergeNode in="saOffsetBlurColor"></feMergeNode>
                <feMergeNode in="SourceGraphic"></feMergeNode>
            </feMerge>
        </filter>

        <filter id="vm-topology-aggregate-entity" x="-20%" y="-20%" width="140%" height="140%">
            <!-- Create two offset clones from the source graphic -->
            <feOffset in="SourceGraphic" result="box1" dx="3" dy="3" />
            <feOffset in="SourceGraphic" result="box2" dx="6" dy="6" />

            <!-- This part is same idea as fdropshadow, but putting the shadow on the bottom box clone -->
            <feGaussianBlur in="box2" result="box2Blur" stdDeviation="2"></feGaussianBlur>
            <feColorMatrix
                in="box2Blur"
                result="box2BlurColor"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            ></feColorMatrix>

            <!-- Merge the layers from bottom to top -->
            <feMerge>
                <feMergeNode in="box2BlurColor" />
                <feMergeNode in="box2" />
                <feMergeNode in="box1" />
                <feMergeNode in="SourceGraphic" />
            </feMerge>
        </filter>

        <!-- Partial selection gradient fills -->
        <linearGradient id="vm-topology-partial-selected-vdisk" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="5%" stop-color="white" />
            <stop offset="95%" stop-color="#e5e1ff" />
        </linearGradient>
        <linearGradient id="vm-topology-partial-selected-vdisk-hover" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="5%" stop-color="white" />
            <stop offset="95%" stop-color="#a395ff" />
        </linearGradient>

        <linearGradient id="vm-topology-partial-selected-vm" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="5%" stop-color="white" />
            <stop offset="95%" stop-color="#c9f7f8" />
        </linearGradient>
        <linearGradient id="vm-topology-partial-selected-vm-hover" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="5%" stop-color="white" />
            <stop offset="95%" stop-color="#85edef" />
        </linearGradient>

        <linearGradient id="vm-topology-partial-selected-host" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="5%" stop-color="white" />
            <stop offset="95%" stop-color="#f7cffe" />
        </linearGradient>
        <linearGradient id="vm-topology-partial-selected-host-hover" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="5%" stop-color="white" />
            <stop offset="95%" stop-color="#eb84fc" />
        </linearGradient>

        <linearGradient id="vm-topology-partial-selected-datastore" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="5%" stop-color="white" />
            <stop offset="95%" stop-color="#d0ffda" />
        </linearGradient>
        <linearGradient id="vm-topology-partial-selected-datastore-hover" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="5%" stop-color="white" />
            <stop offset="95%" stop-color="#84ff9e" />
        </linearGradient>

        <linearGradient id="vm-topology-partial-selected-volume" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="5%" stop-color="white" />
            <stop offset="95%" stop-color="#d4dffe" />
        </linearGradient>
        <linearGradient id="vm-topology-partial-selected-volume-hover" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="5%" stop-color="white" />
            <stop offset="95%" stop-color="#89a7fc" />
        </linearGradient>

        <linearGradient id="vm-topology-partial-selected-array" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="5%" stop-color="white" />
            <stop offset="95%" stop-color="#f6e2d7" />
        </linearGradient>
        <linearGradient id="vm-topology-partial-selected-array-hover" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="5%" stop-color="white" />
            <stop offset="95%" stop-color="#e8b599" />
        </linearGradient>

        <!--
            Snapshot Catalog
        -->
        <filter id="circle-selected-dropshadow" x="-20%" y="-20%" width="200%" height="200%">
            <feGaussianBlur in="SourceGraphic" stdDeviation="1" />
            <feOffset dx="2" dy="2" result="offsetblur" />
            <feFlood flood-color="#8d8d8d" flood-opacity="1" />
            <feComposite in2="offsetblur" operator="in" />
            <feMerge>
                <feMergeNode />
                <feMergeNode in="SourceGraphic" />
            </feMerge>
        </filter>

        <linearGradient id="snapshots-halfhalf" x1="50%" y1="0%" x2="50%" y2="100%" spreadMethod="pad">
            <!-- from the top to 49% of the circle will be color #b5a2dc -->
            <stop offset="49%" stop-color="#b5a2dc" />
            <stop offset="49%" stop-color="#b5a2dc" />
            <!-- a grayish line at the 50% of the circle -->
            <stop offset="50%" stop-color="#cbbee7" />
            <stop offset="50%" stop-color="#cbbee7" />
            <!-- the bottom half of the circle will be color #755baa -->
            <stop offset="51%" stop-color="#755baa" />
            <stop offset="51%" stop-color="#755baa" />
        </linearGradient>
    </defs>
</svg>
